import { AnalysisQuote } from '@/gen/controls/v1/analysis_result_pb'

import { type EventProperties, useTrackCallback } from '@/lib/analytics/events'

import { RISK_QUESTIONNAIRE_THREAD_LABELS } from '@/pages/control/labels'
import {
  citedArtifactKey,
  citedArtifactQuotes,
} from '@/pages/control/risk-questionnaire-thread-card/utils'

import { AnalysisQuoteList } from '@/components/shared/analysis-quotes/analysis-quotes'
import { analysisQuoteTitle } from '@/components/shared/analysis-quotes/utils'

type EvaluationEvidenceProps = {
  quotes: AnalysisQuote[]
  readOnly: boolean
  trackingProps: EventProperties
}

export const EvaluationEvidence = ({
  quotes,
  readOnly,
  trackingProps,
}: EvaluationEvidenceProps) => {
  const trackSourceClicked = useTrackCallback('control.view.activity.source-clicked')
  const artifactQuotes = citedArtifactQuotes(quotes)
  if (artifactQuotes.length === 0) return null

  return (
    <div className='flex flex-col gap-2'>
      <span className='text-main-foreground-tertiary text-label-default'>
        {RISK_QUESTIONNAIRE_THREAD_LABELS.EVIDENCE}
      </span>
      <AnalysisQuoteList
        quotes={artifactQuotes}
        groupBy={citedArtifactKey}
        readonly={readOnly}
        autoOpenSingle={false}
        onOpen={(quote, index) =>
          trackSourceClicked({
            ...trackingProps,
            evidence_label: analysisQuoteTitle(quote),
            evidence_index: index,
          })
        }
      />
    </div>
  )
}
